import {Messages} from '../../constants';

const validation = {
  nome: {
    presence: {
      message: Messages.RequireNameValidationMessage,
      allowEmpty: false,
    },
    format: {
      pattern: /(\w.+\s).+/i,
      message: Messages.RequiredNameFullValidationRequiredMessage,
    },
  },
  sexo: {
    presence: {
      message: Messages.RequireGenderValidationMessage,
      allowEmpty: false,
    },
  },
  nascimento: {
    presence: {
      message: Messages.RequiredBirthdateValidationMessage,
      allowEmpty: false,
    },
    brDate: {
      message: Messages.InvalidBirthdateValidationMessage,
    },
    under18Years: {
      message: Messages.Under18YearsValidationMessage,
    },
    over100Years: {
      message: Messages.Over100YearsValidationMessage,
    },
  },
  autorizacoes: {
    equality: {
      attribute: 'autorizacoesCompare',
      message: Messages.RequiredPoliticsValidationMessage,
      comparator: function (v1, v2) {
        return v1 === v2;
      },
    },
  },
};

export default validation;
